import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "complete-day-more" }
const _hoisted_2 = { class: "bg-white rounded-lg py-3 px-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-8 flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-500" }, " При получении детальной информации произошла ошибка ", -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_12 = { class: "grid grid-cols-2 items-start gap-4" }
const _hoisted_13 = { class: "grid grid-cols-2 items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Доставки за день:", -1)
const _hoisted_15 = { class: "grid grid-cols-2 items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Наличка за доставку:", -1)
const _hoisted_17 = { class: "grid grid-cols-2 items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Отмены за день:", -1)
const _hoisted_19 = { class: "grid grid-cols-2 items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Наложенный платеж:", -1)
const _hoisted_21 = { class: "grid grid-cols-2 items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Возврат выдачи:", -1)
const _hoisted_23 = { class: "grid grid-cols-2 items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Платный проезд:", -1)
const _hoisted_25 = { class: "grid grid-cols-2 items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Заборы:", -1)
const _hoisted_27 = { class: "grid grid-cols-2 items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Платная парковка:", -1)
const _hoisted_29 = { class: "grid grid-cols-2 items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium" }, "Отработанные часы:", -1)
const _hoisted_31 = {
  key: 0,
  class: "bg-white rounded-lg py-3 px-4 mt-5"
}
const _hoisted_32 = { class: "max-w-full overflow-hidden overflow-x-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_complete_day_row = _resolveComponent("complete-day-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, { title: _ctx.pageTitle }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.courier)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["font-medium flex items-center mr-3", {
                            'text-blue-500': _ctx.state.courier.info.isClosed,
                            'text-red-500': !_ctx.state.courier.info.isClosed,
                        }])
              }, [
                (_ctx.state.courier.info.isClosed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_5,
                      _createTextVNode(" Завершено ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_6,
                      _createTextVNode(" Не завершено ")
                    ], 64))
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_new_button, {
            class: "NewButton--reset",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/new-dispatcher/complete-day?date=${_ctx.date_filter}`)))
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Назад ")
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.courier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_9,
                    _createVNode(_component_new_button, {
                      class: "NewButton--outline mt-1",
                      onClick: _ctx.loadDetails
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Перезагрузить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, "Нет данных"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.deliveriesTotal), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.cash) + " ₸", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.cancelledTakes), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.codPayment) + " ₸", 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.returnDeliveryCount), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.costForRoad || 0) + " ₸", 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.takesTotal), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.costForParking || 0) + " ₸", 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", null, _toDisplayString(_ctx.state.courier.info.timeOfWork), 1)
              ])
            ])
          ]))
    ]),
    (Boolean(_ctx.state.courier))
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_new_table, {
              columns: _ctx.COLUMNS,
              rows: _ctx.state.courier.info.detailsOfOrders
            }, {
              td: _withCtx(({ column, row }) => [
                _createVNode(_component_complete_day_row, {
                  column: column,
                  row: row
                }, null, 8, ["column", "row"])
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}